import { UPDATE_REDUX_ENROLLMENT_STATUS } from '../../constants/actionTypes';

const initialState = null;

export default function enrollmentOn(state = initialState, action) {
  switch (action.type) {
    case UPDATE_REDUX_ENROLLMENT_STATUS:
      return action.payload.enrollmentOn;
    default:
      return state;
  }
}
